var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoOngoingRecordingAll = function SvgIcoOngoingRecordingAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9,
    r: 7.6,
    stroke: "#EEE",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M8 5h3.096q.61 0 1.153.124.553.113.96.396.418.271.655.746.249.462.249 1.163 0 .847-.44 1.447-.441.587-1.289.745L14.418 13h-2.113l-1.672-3.198h-.87V13H8zm1.763 3.31h1.04q.236 0 .496-.01.271-.024.486-.102.215-.09.35-.271.148-.181.148-.509 0-.305-.125-.486a.8.8 0 0 0-.316-.271 1.3 1.3 0 0 0-.44-.136 4 4 0 0 0-.487-.033H9.763z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M1.833 9c0 3.195 1.258 6.096 3.304 8.236A9.17 9.17 0 0 1 0 9 9.17 9.17 0 0 1 5.138.764 11.88 11.88 0 0 0 1.833 9m18.334 0c0 3.195-1.258 6.096-3.305 8.236A9.17 9.17 0 0 0 22 9 9.17 9.17 0 0 0 16.863.764 11.88 11.88 0 0 1 20.167 9",
    clipRule: "evenodd"
  })));
};
export default SvgIcoOngoingRecordingAll;